import Icon from '../components/Icon.vue'

Icon.register({
  campground: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M624 448H599.3L359.5 117.8 413 44.2C418.1 37.1 416.6 27 409.4 21.9L383.5 3.1C376.4-2.1 366.4-0.6 361.2 6.6L320 63.3 278.8 6.6C273.6-0.6 263.6-2.1 256.5 3.1L230.6 21.9C223.4 27 221.9 37.1 227.1 44.2L280.5 117.8 40.7 448H16C7.2 448 0 455.2 0 464V496C0 504.8 7.2 512 16 512H624C632.8 512 640 504.8 640 496V464C640 455.2 632.8 448 624 448zM320 288L436.4 448H203.6L320 288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/campground.js
// module id = VziT
// module chunks = 144